import clsx from 'clsx'

/** Malý spinner (tlačítka, načítání uvnitř karty). */
export function Spinner({ className, tone = 'brand' }: { className?: string; tone?: 'brand' | 'white' }) {
  return (
    <svg viewBox="0 0 52 52" role="presentation" className={clsx('inline-block h-5 w-5 shrink-0 animate-spin', className)}>
      <circle cx="26" cy="26" r="22" fill="none" strokeWidth="6" className={tone === 'white' ? 'stroke-white/30' : 'stroke-slate-200'} />
      <circle
        cx="26" cy="26" r="22" fill="none" strokeWidth="6" strokeLinecap="round" strokeDasharray="35 138.2"
        className={tone === 'white' ? 'stroke-white' : 'stroke-brand-600'}
      />
    </svg>
  )
}

/** Obsah stránky se ještě načítá — nikdy prázdná plocha. */
export function PageSpinner({ className, label = 'Načítám…' }: { className?: string; label?: string }) {
  return (
    <div role="status" aria-live="polite" className={clsx('flex flex-col items-center justify-center gap-3 py-12 text-sm text-ink-500', className)}>
      <Spinner className="!h-9 !w-9" />
      <span>{label}</span>
    </div>
  )
}

/** Zástupný šedý blok při načítání (řádky seznamu, dlaždice). */
export function Skeleton({ className }: { className?: string }) {
  return <div aria-hidden className={clsx('animate-pulse rounded-lg bg-slate-200/80', className)} />
}
